import type { ModuleManifestInput } from './manifest.js';

/**
 * Declares a module. The manifest is pure data so it can be shared by the API, the worker and the web shell;
 * server and web code are attached separately (see `@portal/server-kit` and `@portal/web-sdk`).
 * Validation happens when the registry is built, so a broken manifest fails application start-up.
 *
 * Kept apart from the Zod schemas in manifest.ts (type-only import) so web bundles do not pull in Zod.
 */
export function defineModule<const T extends ModuleManifestInput>(manifest: T): T {
  return manifest;
}
